export const RULE_SUGGESTION_STATUSES = [
    'awaiting_review',
    'in_progress',
    'polling',
    'approved',
    'denied',
    'impossible',
];
export const RULE_SUGGESTION_STATUS_LABELS = {
    awaiting_review: 'Awaiting review',
    in_progress: 'In progress',
    polling: 'Polling',
    approved: 'Approved',
    denied: 'Denied',
    impossible: 'Impossible',
};
/** Statuses shown in the "open" section at the top of the rules page. */
export const OPEN_RULE_STATUSES = [
    'in_progress',
    'polling',
    'awaiting_review',
];
/** Where a Sleeper league id lives on the web. */
export function sleeperLeagueUrl(leagueId) {
    return `https://sleeper.com/leagues/${leagueId}/league`;
}
//# sourceMappingURL=types.js.map